var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideshow-page"},[(_vm.loaded)?_c('Slideshow',{attrs:{"slides":_vm.slides || _vm.wpSlides,"settings":_vm.slideshowSettings,"hasPopup":true}}):_vm._e(),_c('PageDescription',{attrs:{"post":_vm.post}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }